import { RoundedStatusBadge } from "../../../../components/RoundedStatusBadge/RoundedStatusBadge";

interface HitTypeTagProps {
  type: string | null;
}

const HitTypeTag: React.FC<HitTypeTagProps> = ({ type }) => {
  return type ? (
    <RoundedStatusBadge variant={type === "miss" ? "red" : "green"}>
      Cache <span className="text-uppercase">{type}</span>
    </RoundedStatusBadge>
  ) : null;
};

export { HitTypeTag };
